import { render, staticRenderFns } from "./CoverYearTaux.vue?vue&type=template&id=32623ef6"
import script from "./CoverYearTaux.vue?vue&type=script&lang=js"
export * from "./CoverYearTaux.vue?vue&type=script&lang=js"
import style0 from "./CoverYearTaux.vue?vue&type=style&index=0&id=32623ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports